/*eslint-disable lodash/prefer-lodash-method*/
import over from 'lodash/over';
import range from 'lodash/range';
import debounce from 'lodash/debounce';
import uniqueId from 'lodash/uniqueId';
import get from 'lodash/get';
import cmp from '../../lib/cmp';
import { smap } from '../../lib/utils';
import on from '../../lib/dom/on';
import setStyle from '../../lib/dom/set-style';
import onScroll from '../../lib/dom/on-page-scroll';
import scrollElement from '../../lib/dom/element-scroll';
import Siema from '../../vendor/siema';
import onResize from '../../lib/dom/on-resize';
import onDelay from '../../lib/dom/on-delay';
import onHashChange from '../../lib/dom/on-hashchange';
import selectByClass, { selectOne } from '../../lib/dom/select-by-class';
import iterateElements, { map as mapElements } from '../../lib/dom/iterate';
import elementClosest from '../../lib/dom/element-closest';
import elementSize from '../../lib/dom/element-size';
import viewportSize from '../../lib/dom/viewport-size';
import { addClass, hasClass, removeClass } from '../../lib/dom/className';
import smRatio from '../../components/sm-ratio/sm-ratio';
import bindVideoPlaying from '../../lib/bind-event-tracking/video-watching';
import './sm-landing-appstore-app-1-gallery.less';
import { IPHONE_SCREEN_TYPE } from '../../config/constants';
import {
  getAppScreenshotSrcSet,
  getAppVideoPoster,
  getAppVideoSrc
} from '../../lib/srcSetService';
import { isRtl } from '../../lib/document-dir-utils';
import { slideVideoWrapper, videoPopupWrapper } from '../../lib/video-api-wrapper';



const PIXEL_SRC = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
const GENERAL_HASH = '#';
const FULLSCREEN_GALLERY_ACTIVE_HASH = '#gallery';
const FULLSCREEN_VIDEO_ACTIVE_HASH = '#video';

const SLIDE_CLASS = 'sm-landing-appstore-app-1-gallery__slide';
const FRAME_CLASS = 'sm-landing-appstore-app-1-gallery__frame';
const SLIDE_CV_CLASS = 'sm-landing-appstore-app-1-gallery__slide-cv';
const SLIDE_IN_CLASS = 'sm-landing-appstore-app-1-gallery__slide-in';
const SLIDE_IMG_CLASS = 'sm-landing-appstore-app-1-gallery__slide-img';
const SLIDE_IMG_CLASS_ROTATE = 'sm-landing-appstore-app-1-gallery__slide-img--rotate';
const SLIDE_VIDEO_CLASS = 'sm-landing-appstore-app-1-gallery__slide-video';
const SLIDE_CANPLAY_CLASS = 'sm-landing-appstore-app-1-gallery__slide--canplay';
const SLIDE_VIDEO_ACTIVE_CLASS = 'sm-landing-appstore-app-1-gallery__slide--video-active';
const POPUP_GALLERY_CLASS = 'sm-landing-appstore-app-1-gallery__popup-gallery';
const POPUP_GALLERY_ACTIVE_CLASS = 'sm-landing-appstore-app-1-gallery__popup-gallery--active';
const POPUP_GALLERY_FRAME_CLASS = 'sm-landing-appstore-app-1-gallery__popup-gallery-frame';
const HTML_POPUP_ACTIVE_CLASS = '-sm-landing-appstore-app-1-gallery--popup-active';
const MAIN_GALLERY_SLIDE_CLASS = 'sm-landing-appstore-app-1-gallery__main-gallery-slide';
const MAIN_GALLERY_FRAME_CLASS = 'sm-landing-appstore-app-1-gallery__main-gallery-frame';
const MAIN_GALLERY_SLIDE_SCREENSHOT_CLASS = 'sm-landing-appstore-app-1-gallery__main-gallery-slide--screenshot';
const MAIN_GALLERY_SLIDE_VIDEO_CLASS = 'sm-landing-appstore-app-1-gallery__main-gallery-slide--video';
const VIDEO_POPUP_CLASS = 'sm-landing-appstore-app-1-gallery__video-popup';
const VIDEO_POPUP_VIDEO_CLASS = 'sm-landing-appstore-app-1-gallery__video-popup-video';
const VIDEO_POPUP_VERTICAL_VIDEO_CLASS = 'sm-landing-appstore-app-1-gallery__video-popup-video-vertical';
const VIDEO_POPUP_CLOSE_CLASS = 'sm-landing-appstore-app-1-gallery__video-popup-close';
const VIDEO_POPUP_PLAY_CLASS = 'sm-landing-appstore-app-1-gallery__video-popup-play';
const VIDEO_POPUP_ACTIVE_CLASS = 'sm-landing-appstore-app-1-gallery__video-popup--active';
const VIDEO_POPUP_CONTROLS_ACTIVE_CLASS = 'sm-landing-appstore-app-1-gallery__video-popup--controls-active';
const VIDEO_POPUP_PLAYING_CLASS = 'sm-landing-appstore-app-1-gallery__video-popup--playing';

const getPopupGalleryCloseClass = (isRtl = false) => `sm-landing-appstore-app-1-gallery__popup-gallery-header${isRtl ? '-rtl' : ''}`;

const INVISIBLE = uniqueId('invisible');
const VISIBLE = uniqueId('visible');

const IPAD_SIZE = 640;

const SPACE_BETWEEN_SCREENS = 10;

const isTabletDevice = () => (viewportSize.width >= IPAD_SIZE && viewportSize.height >= IPAD_SIZE);

const calcScreenshotArea = (width, height) => {
  const PADDING = window.iphoneScreenSize === IPHONE_SCREEN_TYPE.SCREEN_4_0 ? 16 : 20;

  if (isTabletDevice()) {
    const maxHeightAreaInIpad = 256;

    return {
      width: width / height * maxHeightAreaInIpad,
      height: maxHeightAreaInIpad
    };
  }

  if (width > height) {
    const imageScale = (viewportSize.width - PADDING * 2) / width;

    return {
      width: viewportSize.width - (PADDING * 2),
      height: height * imageScale
    };
  }

  const imagesPerPreview = 1.5;
  const imageScale = (viewportSize.width - PADDING - SPACE_BETWEEN_SCREENS * 2) / (imagesPerPreview * width);

  return {
    width: viewportSize.width - PADDING,
    height: height * imageScale
  };
};

const slideScreenshot = ($cmp, className = '') => ({ url, width, height, $index, $id, screen_type, versions }) => {
  const srcSet = getAppScreenshotSrcSet({ versions, width, height, screen_type }, true);
  const postponedLoading = $index >= 2;

  return `
    <div class="${SLIDE_CLASS} ${className} img-${screen_type}" data-index="${$index}" data-id="${$id}">
      ${$cmp(SLIDE_IN_CLASS, smRatio, { width, height, area: calcScreenshotArea(width, height), body: `<div class="${SLIDE_CV_CLASS} img-container ${width > height ? 'horizontal' : 'vertical'}">
      <img class="${SLIDE_IMG_CLASS} ${postponedLoading ? 'postponed-image' : ''}" srcset="${!postponedLoading ? srcSet : ''}" data-src="${url}" data-srcset="${srcSet}" src="${!postponedLoading ? url : PIXEL_SRC}" />
      </div>` })}
    </div>
  `;
};


const mkScreenshotRotateSizes = (screenRatio) => {
  screenRatio = (Math.round(screenRatio * 100) / 100);

  const areaWidth = viewportSize.width - 40; // 40 - gallery left and right offset
  const areaHeight = viewportSize.height - 90; // 42 - gallery header and bottom offset

  const height = areaHeight / screenRatio;
  const isBigArea = height <= areaWidth;
  const width = Math.round(isBigArea ? areaHeight : areaWidth * screenRatio) - 2;// really need for border-offset

  return {
    width,
    offsetTop: isBigArea ? 0 : ((width - areaHeight) / 2),
    offsetLeft: isBigArea ? ((areaWidth - height) / 2) : 0,
    areaHeight,
    areaWidth
  };
};

const slideRotateScreenshot = cmp(null, ($cmp, { url, width, height, $index, $id, className, screen_type, versions }) => {
  const srcSet = getAppScreenshotSrcSet({ versions, width, height, screen_type }, false);

  return `
    <div class="${className} ${SLIDE_CLASS}" data-index="${$index}" data-id="${$id}">
      ${$cmp(SLIDE_IN_CLASS, smRatio, { width, height, area: calcScreenshotArea(width, height), body: `
        <div class="${SLIDE_CV_CLASS}">
          <img class="${SLIDE_IMG_CLASS} rotated-img" srcset="${$index <= 1 ? srcSet : ''}" data-src="${url}" data-srcset="${srcSet}" src="${$index <= 1 ? url : PIXEL_SRC}"/>
        </div>
    ` })}
    </div>
  `;
}, (element, { width, height }) => {
  const screenEl = selectOne(element, SLIDE_IMG_CLASS);
  let rationSizes = mkScreenshotRotateSizes(width / height);

  if (viewportSize.width < viewportSize.height) {
    addClass(screenEl, SLIDE_IMG_CLASS_ROTATE);
    setStyle(screenEl, 'maxWidth', `${rationSizes.areaHeight}px`);
    setStyle(screenEl, 'maxHeight', `${rationSizes.areaWidth}px`);

  } else {
    removeClass(screenEl, SLIDE_IMG_CLASS_ROTATE);

    setStyle(screenEl, 'width', 'auto');
    setStyle(screenEl, 'marginLeft', 0);
    setStyle(screenEl, 'marginTop', 0);
  }
  return [
    onResize(() => {
      if (viewportSize.width < viewportSize.height) {
        addClass(screenEl, SLIDE_IMG_CLASS_ROTATE);

        rationSizes = mkScreenshotRotateSizes(width / height);

        setStyle(screenEl, 'width', rationSizes.width ? `${rationSizes.width}px` : 'auto');
        setStyle(screenEl, 'marginLeft', `${rationSizes.offsetLeft}px`);
        setStyle(screenEl, 'marginTop', `${rationSizes.offsetTop}px`);
      } else {
        removeClass(screenEl, SLIDE_IMG_CLASS_ROTATE);

        setStyle(screenEl, 'width', 'auto');
        setStyle(screenEl, 'marginLeft', 0);
        setStyle(screenEl, 'marginTop', 0);
      }
    })
  ];
});

const slideScreenshotPopup = ($cmp, className = '') => ({ url, width, height, $index, $id, screen_type, versions }) => {
  if (width < height || isTabletDevice()) {
    return slideScreenshot($cmp, className)({ url, width, height, $index, $id, screen_type, versions });
  }

  return $cmp(className, slideRotateScreenshot, { url, width, height, $index, $id, className, versions, screen_type });
};

const slideVideo = ($cmp, className = '') => ({ url: videoUrl, screen_type, versions, preview, $id, $index }) => {
  return `
    <div class="${SLIDE_CLASS} ${className}" data-index="${$index}" data-id="${$id}">
      ${$cmp(SLIDE_IN_CLASS, smRatio, { width: preview.width, height: preview.height, area: calcScreenshotArea(preview.width, preview.height), body: `
    <div class="${SLIDE_CV_CLASS} img-container">
    <video class="${SLIDE_VIDEO_CLASS}" loop muted defaultMuted playsinline controlsList="nodownload nofullscreen noremoteplayback" preload="auto" poster="${getAppVideoPoster(preview)}">
      <source src="${getAppVideoSrc({ versions, screen_type, url: videoUrl, preview })}" />
    </video>
      <div class="sm-landing-appstore-app-1-gallery__slide-video-play"></div>
    </div>` })}
  </div>
  `;
};


const videoPopup = (className = '') => ({ url: videoUrl, screen_type, versions, preview }) => {
  return `
<div class="${VIDEO_POPUP_CLASS} ${className}">
  <div class="sm-landing-appstore-app-1-gallery__video-popup-in">
    <video
      playsinline
      class="${VIDEO_POPUP_VIDEO_CLASS} ${preview && preview.height > preview.width ? VIDEO_POPUP_VERTICAL_VIDEO_CLASS : ''}"
      controlsList="nodownload nofullscreen noremoteplayback"
      preload="auto"
      poster="${getAppVideoPoster(preview)}"
    >
      <source src="${getAppVideoSrc({ versions, screen_type, url: videoUrl, preview })}" />
    </video>
  </div>
  <div class="${VIDEO_POPUP_CLOSE_CLASS}">close</div>
  <div class="${VIDEO_POPUP_PLAY_CLASS}">
    <div class="sm-landing-appstore-app-1-gallery__video-popup-play-icon-play">play</div>
    <div class="sm-landing-appstore-app-1-gallery__video-popup-play-icon-pause">pause</div>
  </div>
</div>`;
};


export default cmp(
  (data) => {
    return ({
      appleWatch: data.appleWatch,
      videos: data.videos || [],
      screenshots: data.screenshots || [],
      galleryTracking: data.galleryTracking
    });
  },
  ($cmp, { videos, screenshots, appleWatch = false }) => {
    const imageScreenType = get(videos, '[0].preview.screen_type') || get(screenshots, '[0].screen_type', 'default');

    return `
      <div class="sm-landing-appstore-app-1-gallery ${appleWatch ? 'sm-landing-appstore-app-1-gallery--apple-watch' : 'sm-landing-appstore-app-1-gallery--main'}">
        <div class="sm-landing-appstore-app-1-gallery__main-gallery">
          <div class="sm-landing-appstore-app-1-gallery__main-gallery-frame-wr">
            <div class="${FRAME_CLASS} img-${imageScreenType} ${MAIN_GALLERY_FRAME_CLASS}">
              ${smap(videos, slideVideo($cmp, `${MAIN_GALLERY_SLIDE_CLASS} ${MAIN_GALLERY_SLIDE_VIDEO_CLASS}`))}
              ${screenshots.length ? smap(screenshots, slideScreenshot($cmp, `${MAIN_GALLERY_SLIDE_CLASS} ${MAIN_GALLERY_SLIDE_SCREENSHOT_CLASS}`)) : ''}
            </div>
          </div>
        </div>

        <div class="${POPUP_GALLERY_CLASS}">
          <div class="${getPopupGalleryCloseClass(isRtl())}">${__('sm@_done')}</div>
          <div class="sm-landing-appstore-app-1-gallery__popup-gallery-frame-wr">
            <div class="${FRAME_CLASS} img-${imageScreenType} ${POPUP_GALLERY_FRAME_CLASS}">
              ${screenshots.length ? smap(screenshots, slideScreenshotPopup($cmp, 'sm-landing-appstore-app-1-gallery__popup-gallery-slide')) : ''}
            </div>
          </div>
        </div>
        ${smap(videos, videoPopup())}
      </div>
    `;
  },
  (element, { videos, screenshots, galleryTracking = {} }) => {
    const mainGalleryFrameElement = selectOne(element, MAIN_GALLERY_FRAME_CLASS);
    const popupGalleryElement = selectOne(element, POPUP_GALLERY_CLASS);
    const popupGalleryFrameElement = selectOne(popupGalleryElement, POPUP_GALLERY_FRAME_CLASS);
    const popupCloseElement = selectByClass(popupGalleryElement, getPopupGalleryCloseClass(isRtl()));
    const videoPopupElements = selectByClass(element, VIDEO_POPUP_CLASS);
    const videoPopupVideoElements = selectByClass(element, VIDEO_POPUP_VIDEO_CLASS);
    const slideVideoElements = selectByClass(element, SLIDE_VIDEO_CLASS);
    const videoSlideElements = selectByClass(element, MAIN_GALLERY_SLIDE_VIDEO_CLASS);
    const popupGallerySlideImgElements = selectByClass(popupGalleryFrameElement, SLIDE_IMG_CLASS);
    const mainGallerySlideImgElements = selectByClass(mainGalleryFrameElement, SLIDE_IMG_CLASS);
    const videoPopupCloseElements = selectByClass(element, VIDEO_POPUP_CLOSE_CLASS);
    const videoPopupPlayElements = selectByClass(element, VIDEO_POPUP_PLAY_CLASS);

    const gallerySlideIds = mapElements(selectByClass(mainGalleryFrameElement, MAIN_GALLERY_SLIDE_CLASS), (item) => item.getAttribute('data-id'));

    const screenshotStart = selectOne(mainGalleryFrameElement, MAIN_GALLERY_SLIDE_SCREENSHOT_CLASS);
    const screenshotStartDataIndex = screenshotStart ? Number(screenshotStart.getAttribute('data-index')) : 0;

    const videoStart = selectOne(mainGalleryFrameElement, MAIN_GALLERY_SLIDE_VIDEO_CLASS);
    const videoStartDataIndex = videoStart ? Number(videoStart.getAttribute('data-index')) : 0;

    const calcRealIndex = (index) => Number(index) + screenshotStartDataIndex;

    const track = ({
      onInit (/*screenshotImages, videoIndex*/) {},
      onSwitchSlide (/*popupIsOpen, slideIndex, isVideo*/) {},
      onTransitionEnd (/*popupIsOpen*/) {},
      onClosePopup (/*slideIndex, isVideo*/) {},
      onOpenPopup (/*slideIndex, isVideo*/) {},
      ...galleryTracking
    });

    const popup = {
      scrollingElement: scrollElement(),
      scrollTop: null,
      offDelay: () => {},
      activate () {
        this.offDelay();
        if (this.scrollTop === null) {
          addClass(document.documentElement, HTML_POPUP_ACTIVE_CLASS);
          this.scrollTop = this.scrollingElement.scrollTop;
        }
      },
      deactivate () {
        if (this.scrollTop !== null) {
          removeClass(document.documentElement, HTML_POPUP_ACTIVE_CLASS);
          const scrollTop = this.scrollTop;

          this.offDelay();
          this.offDelay = onDelay(() => { // hack
            this.scrollingElement.scrollTop = scrollTop;
          });

          this.scrollTop = null;
        }
      }
    };

    const slideVideo = slideVideoWrapper(
      videos, videoSlideElements, slideVideoElements,
      {
        states: {
          visible: VISIBLE,
          invisible: INVISIBLE
        },
        classes: {
          slideVideoActiveClass: SLIDE_VIDEO_ACTIVE_CLASS
        }
      }
    );

    const videoPopup = videoPopupWrapper(
      slideVideo, popup, videoPopupElements, videoPopupVideoElements,
      {
        withControls: true,
        classes: {
          videoPopupControlsActiveClass: VIDEO_POPUP_CONTROLS_ACTIVE_CLASS,
          videoPopupActiveClass: VIDEO_POPUP_ACTIVE_CLASS,
          videoPopupPlayingClass: VIDEO_POPUP_PLAYING_CLASS
        },
        locations: {
          root: GENERAL_HASH,
          fullscreenVideoActive: FULLSCREEN_VIDEO_ACTIVE_HASH
        }
      }
    );

    const popupGallery = new Siema(popupGalleryFrameElement, {
      beforeRefresh () {
        const { width, height } = elementSize(this.slider);

        iterateElements(popupGalleryFrameElement.children, (element) => {
          element.style.width = `${width}px`;
          element.style.height = `${height}px`;
        });
      },
      onChange (slideIndex) {
        const _index = calcRealIndex(slideIndex);

        track.onSwitchSlide(true, _index, false, gallerySlideIds);
      }
    });

    const fullscreenGallery = {
      isActive: false,
      slideChange (index) {
        popupGallery.goTo(index, true);
      },
      activate (index) {
        this.isActive = true;
        addClass(popupGalleryElement, POPUP_GALLERY_ACTIVE_CLASS);
        popupGallery.refresh();
        popup.activate();

        const _index = index - screenshotStartDataIndex; //NOTE excluded video from popup gallery

        this.slideChange(_index, true);

        track.onOpenPopup(calcRealIndex(_index), false, gallerySlideIds);

        window.location.hash = FULLSCREEN_GALLERY_ACTIVE_HASH;
      },
      deactivate () {
        this.isActive = false;
        removeClass(popupGalleryElement, POPUP_GALLERY_ACTIVE_CLASS);
        popup.deactivate();

        track.onClosePopup(popupGallery.currentSlide, false, gallerySlideIds);

        window.location.hash = GENERAL_HASH;
      }
    };

    let offScrollingInitialAutoplayListener = () => {};

    const mainGallery = new Siema(mainGalleryFrameElement, {
      onBeforeChange (index) {
        fullscreenGallery.slideChange(index);
      },
      onClick (ev) {
        const slideElement = elementClosest((element) => hasClass(element, MAIN_GALLERY_SLIDE_CLASS), ev.target, mainGalleryFrameElement);
        const dataIndex = Number(slideElement.getAttribute('data-index'));

        if (hasClass(slideElement, MAIN_GALLERY_SLIDE_SCREENSHOT_CLASS)) {
          startLoadingRotatedScreens();
          fullscreenGallery.activate(dataIndex);
        } else {
          videoPopup.activate(dataIndex - videoStartDataIndex);
        }
      },
      onChange (slideIndex) {
        if (slideIndex < videos.length) {
          offScrollingInitialAutoplayListener();

          slideVideo.pause();
          if (videos[slideIndex].autoplay) {
            slideVideo.play(slideIndex);
          }

          track.onSwitchSlide(false, slideIndex, true, gallerySlideIds);
        } else {
          slideVideo.pause();

          track.onSwitchSlide(false, slideIndex, false, gallerySlideIds);
        }
      }
    });

    if (!screenshots && Array.isArray(videos) && videos.length === 1) {
      mainGallery.disable({ disableClick: false });
    }

    let cleanups = [];

    if (videos.length) {
      cleanups = cleanups.concat(mapElements(slideVideoElements, (videoElement, index) =>
        bindVideoPlaying(videoElement, index, () => ({
          activate: false,
          full_screen: false,
          video_id: videos[index].$id
        }))
      ));

      cleanups = cleanups.concat(mapElements(videoPopupVideoElements, (videoElement, index) =>
        bindVideoPlaying(videoElement, index, () => ({
          activate: true,
          full_screen: true,
          video_id: videos[index].$id
        }))
      ));

      let initialized = false;

      offScrollingInitialAutoplayListener = () => {
        initialized = true;
      };

      cleanups.push(onScroll(() => {
        const state = slideVideo.currentState(mainGallery.currentSlide);

        if (initialized) {
          if (state === VISIBLE) {
            slideVideo.play(mainGallery.currentSlide);
          } else {
            slideVideo.pause();
          }
        } else {
          if (!videos[0].autoplay || !state) {
            offScrollingInitialAutoplayListener();
          }

          if (state === VISIBLE) {
            offScrollingInitialAutoplayListener();
            slideVideo.play(0);
          }
        }
      }, true, 300));
    }

    track.onInit(mainGallerySlideImgElements, popupGallerySlideImgElements, range(0, videos.length, 1), gallerySlideIds);

    cleanups.push(onHashChange(({ to }) => {
      if (fullscreenGallery.isActive && to !== FULLSCREEN_GALLERY_ACTIVE_HASH) {
        fullscreenGallery.deactivate();
      }

      if (videoPopup.isActive && to !== FULLSCREEN_VIDEO_ACTIVE_HASH) {
        videoPopup.deactivate();
      }

      if (to === FULLSCREEN_GALLERY_ACTIVE_HASH && slideVideo.isPlaying) {
        slideVideo.pause();
      }
    }));

    return [
      ...cleanups,
      onResize(debounce(over([
        mainGallery.refresh,
        popupGallery.refresh
      ]), 100)),
      on(slideVideoElements, 'canplay', (ev) => {
        const slideElement = elementClosest((element) => hasClass(element, SLIDE_CLASS), ev.target, mainGalleryFrameElement);

        addClass(slideElement, SLIDE_CANPLAY_CLASS);
      }),
      on(popupCloseElement, 'click', () => {
        fullscreenGallery.deactivate();
        mainGallery.refresh();
      }),
      on(videoPopupVideoElements, 'ended', () => {
        videoPopup.deactivate();
      }),
      on(videoPopupElements, 'click', () => {
        videoPopup.activateControls();
      }),
      on(videoPopupPlayElements, 'click', () => {
        videoPopup.togglePlay();
      }),
      on(videoPopupCloseElements, 'click', () => {
        videoPopup.deactivate();
      })
    ];
  }
);

function startLoadingRotatedScreens () {
  replaceImageSrc('.rotated-img');
}

function replaceImageSrc (selector) {
  const imageElements = document.querySelectorAll(selector);

  for (const imageElement of imageElements) {
    if (imageElement.src === PIXEL_SRC) {
      const { srcset, src } = imageElement.dataset;

      imageElement.setAttribute('srcset', srcset);
      imageElement.setAttribute('src', src);
    }
  }
}

setTimeout(replaceImageSrc, 1000, '.postponed-image');
setTimeout(startLoadingRotatedScreens, 3000);



// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/sm-landing-appstore-app-1-gallery/sm-landing-appstore-app-1-gallery.js